import authenticated from '@/middleware/authenticated';
import PageWriter from '@/components/writer/PageWriter.vue';
import Book from "@/pages/Book.vue";

export default [
    {
        path: '/books/:bookId',
        name: 'library.books',
        component: Book,
        meta: { middleware: [authenticated] },
        children: [
            {
                path: 'pages/:pageId',
                name: 'library.books.pages',
                component: PageWriter,
                meta: { middleware: [authenticated] },
            }
        ]
    }
];
